import { Grid, Skeleton } from "@mui/material";
import { memo, useEffect, useState } from "react";
import ClickButton from "../../components/button/ClickButton";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { getUserStatusCountApi } from "../../apis/user.api";

const UserCountComponent = ({ filters, setFilters }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchCountFun = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getUserStatusCountApi({ ...filters }),
        (response) => {
          setData(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };
  useEffect(() => {
    fetchCountFun();
  }, []);

  if (loading)
    return (
      <Grid container spacing={2}>
        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="150px" />
        </Grid>
        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="150px" />
        </Grid>
        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="150px" />
        </Grid>

        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="150px" />
        </Grid>
      </Grid>
    );

  if (data.length > 0)
    return (
      <Grid container spacing={2}>
        {data.map((item) => (
          <Grid item key={item.role} xs={6} md={12 / data.length}>
            <ClickButton
              onClick={() =>
                setFilters({
                  ...filters,
                  role: item.role,
                  pageNo: 1,
                })
              }
              active={filters.role == item.role}
              title={item.count}
              subTitle={item.label}
            />
          </Grid>
        ))}
      </Grid>
    );

  return <></>;
};

export default memo(UserCountComponent);
